/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Conversion_DescriptionInputs */

const et_service_conversion_description = /** @type {(inputs: Service_Conversion_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muuda rohkem külastajaid ostjateks. Optimeerime sinu veebilehe igat osa, et suurendada konversioonimäära ja käivet.`)
};

const en_service_conversion_description = /** @type {(inputs: Service_Conversion_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convert more visitors into customers. We optimize every part of your website to increase conversion rates and revenue.`)
};

/**
* | output |
* | --- |
* | "Convert more visitors into customers. We optimize every part of your website to increase conversion rates and revenue." |
*
* @param {Service_Conversion_DescriptionInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const service_conversion_description = /** @type {((inputs?: Service_Conversion_DescriptionInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Conversion_DescriptionInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_service_conversion_description(inputs)
	return en_service_conversion_description(inputs)
});